/* eslint-disable import/prefer-default-export */
import useSWR from "swr";
import { buildAuditRowsQueryParams, getAuditRows } from "./audit-service";
import { AuditRowQueryParams, AuditRowsGroupedResult } from "./audit-types";

export const useAuditRows = (params: AuditRowQueryParams | null) => {
  const key = params
    ? `/audit/${params.typeKey}/rows?${new URLSearchParams(
        buildAuditRowsQueryParams(params),
      ).toString()}`
    : null;

  const { data, error, isLoading, mutate } = useSWR<AuditRowsGroupedResult>(
    key,
    () => getAuditRows(params as AuditRowQueryParams),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      // Keep the current page visible while the next loads; otherwise rowCount
      // drops to 0 and the DataGrid snaps pagination back to page 0.
      keepPreviousData: true,
    },
  );

  const refresh = async () => {
    await mutate();
  };

  return { data, error, isLoading, refresh };
};
